/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_DownloadedInputs */

const en_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview thumbnail downloaded successfully`)
};

const fr_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniature de previsualisation telechargee avec succes`)
};

const de_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschaubild erfolgreich heruntergeladen`)
};

const it_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima miniatura scaricata correttamente`)
};

const ru_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр миниатюры успешно загружен.`)
};

const es_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa en miniatura descargada exitosamente`)
};

const zh_cn2_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览缩略图已成功下载`)
};

const ja_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューサムネイルが正常にダウンロードされました`)
};

const hi_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन थंबनेल सफलतापूर्वक डाउनलोड हो गया`)
};

const pt_pt2_video_export_preview_downloaded = /** @type {(inputs: Video_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniatura de pré-visualização baixada com sucesso.`)
};

/**
* | output |
* | --- |
* | "Preview thumbnail downloaded successfully" |
*
* @param {Video_Export_Preview_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_downloaded = /** @type {((inputs?: Video_Export_Preview_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_downloaded(inputs)
	if (locale === "de") return de_video_export_preview_downloaded(inputs)
	if (locale === "it") return it_video_export_preview_downloaded(inputs)
	if (locale === "ru") return ru_video_export_preview_downloaded(inputs)
	if (locale === "es") return es_video_export_preview_downloaded(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_downloaded(inputs)
	if (locale === "ja") return ja_video_export_preview_downloaded(inputs)
	if (locale === "hi") return hi_video_export_preview_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_downloaded(inputs)
	return en_video_export_preview_downloaded(inputs)
});